export const acceptableFileTypesForWebp = /(jpg|jpeg|png|apng)/i
